import { Component, OnInit, inject } from '@angular/core';
import { BaseComponent } from 'src/app/core';

import { ProductService } from 'src/app/services';

import { SelectBulkProductComponent } from 'src/app/modules/pc/_component/select-bulk-product/select-bulk-product.component';

@Component({
  selector: 'app-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss'],
  providers: [SelectBulkProductComponent],
  standalone: false,
})
export class AddToCartComponent extends BaseComponent {
  productService = inject(ProductService);
  private selectBulkProduct = inject(SelectBulkProductComponent);

  onAddToCart() {
    // window.alert(`${this.productService.selectProducts.length}건 카트에 담기 아직 API 개발전`);
    if (this.productService.selectProducts.length !== 0) this.productService.emitCloseModal();
  }

  reset() {
    this.productService.selectProducts = [];
    this.productService.emitResetProduct();
  }
}
